// Generated by CoffeeScript 2.7.0
var AssignmentSettingsModal;

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

import AssignmentSettingsModalMixin from 'trunks/vue/share/mixins/yet_another_workflow/assignment_settings_modal.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import CarbonCopyAssignmentSetting from 'trunks/vue/admin/compositions/assignment_settings/carbon_copy.js';

import DurationThresholdAssignmentSetting from 'trunks/vue/admin/compositions/assignment_settings/duration_threshold.js';

import EsignatureAssignmentSetting from 'trunks/vue/admin/compositions/assignment_settings/esignature.js';

import NextReviewerAssignmentSetting from 'trunks/vue/admin/compositions/assignment_settings/next_reviewer.js';

import RefuseReviewerAssignmentSetting from 'trunks/vue/admin/compositions/assignment_settings/refuse_reviewers.js';

import NextVertexAssignmentSetting from 'trunks/vue/admin/compositions/assignment_settings/next_vertex.js';

import TransferAssignmentSetting from 'trunks/vue/admin/compositions/assignment_settings/transfer.js';

import RefuseVerticesSettings from 'trunks/vue/admin/compositions/assignment_settings/refuse_vertices.js';

export default AssignmentSettingsModal = Vue.extend({
  mixins: [AssignmentSettingsModalMixin],
  components: {
    'modal': Modal,
    'next-vertex-setting': NextVertexAssignmentSetting,
    'next-reviewer-setting': NextReviewerAssignmentSetting,
    'refuse-reviewers-setting': RefuseReviewerAssignmentSetting,
    'duration-threshold-setting': DurationThresholdAssignmentSetting,
    'carbon-copy-setting': CarbonCopyAssignmentSetting,
    'esignature-setting': EsignatureAssignmentSetting,
    'transfer-setting': TransferAssignmentSetting,
    'refuse-verteices-settings': RefuseVerticesSettings
  },
  template: `<modal :title='modalTitle'
       extendClass='assignment-setting-modal'
       :backdrop='true'
       ref='modal'>
  <div class="settings-wrapper">
    <transfer-setting v-if='isTransferSetting' ref='transferSettingRef' />
    <template v-if='!isTransferSetting && !isRefuseSetting'>
      <next-vertex-setting :vertexlist='nextVertices'
                           v-if="nextVertices.length !== 1 || currentVertex.dig('settings', 'assign_manually')"
                           @vertexChange='vertexChangedFunc'
                           ref='nextVertexSettingRef'/>
      <next-reviewer-setting v-if="currentVertex.dig('settings', 'assign_manually') && !nextVertexIsFinal && !nextVertex.dig('automatic')"
                             :resource='reviewerRemote'
                             :vertex="currentVertex"
                             ref='nextReviewerSettingRef'/>
      <duration-threshold-setting :settingables='timeLimitSettingables'
                                  v-if='timeLimitSettingables.length'
                                  ref='durationThresholdSettingRef'/>
    </template>
    <template v-if="isRefuseSetting">
      <refuse-verteices-settings v-if="currentVertex.dig('settings', 'refuse_mode') !== 1 || currentVertex.dig('settings', 'refuse_reviewers_mode') === 1"
                                 ref="refuseVertiesSettingRef"
                                 :vertexlist="refuseVertices"
                                 @vertexChange='refuseVertexChangedFunc'/>
      <refuse-reviewers-setting v-if="currentVertex.dig('settings', 'refuse_reviewers_mode') === 1"
                                :resource='refuseReviewersRemote'
                                :vertex="currentVertex"
                                ref='refuseReviewersSettingRef'/>
    </template>
    <carbon-copy-setting v-if="currentVertex.dig('settings', 'carbon_copy', 'enable_manual')"
                        ref='carbonCopySettingRef'/>
    <esignature-setting v-if="currentVertex.dig('operations', 'esignature', 'enabled')"
                        ref='esignatureSettingRef' />
  </div>
  <div class="modal-footer" slot='footer'>
    <button class="link-btn btn-default btn-large" @click='close'>取消</button>
    <button class="btn-large" :disabled="!valid" @click='ensure'>{{ actionText }}</button>
  </div>
</modal>`,
  data: function() {
    return {
      valid: true
    };
  },
  computed: {
    modalTitle: function() {
      return `${this.actionText}设置`;
    }
  },
  methods: {
    getData: function() {
      var data, esignatureSetting, ref, ref1, ref2, refuseReviewersSetting, transferSetting;
      transferSetting = ((ref = this.$refs.transferSettingRef) != null ? ref.getData() : void 0) || null;
      if (this.$refs.transferSettingRef) {
        if (!transferSetting) {
          return;
        }
      }
      esignatureSetting = ((ref1 = this.$refs.esignatureSettingRef) != null ? ref1.getData() : void 0) || '';
      if (this.$refs.esignatureSettingRef) {
        if (!esignatureSetting) {
          return;
        }
      }
      refuseReviewersSetting = ((ref2 = this.$refs.refuseReviewersSettingRef) != null ? ref2.getData() : void 0) || [];
      data = this.getBaseData();
      return _.extend(data, {
        esignature: esignatureSetting
      }, {
        transfer_to_user_id: transferSetting
      }, {
        refuse_to_reviewer_ids: refuseReviewersSetting
      });
    },
    getValid: function() {
      var nextReviewerValid, refuseReviewersValid;
      nextReviewerValid = this.$refs.nextReviewerSettingRef ? this.$refs.nextReviewerSettingRef.getValid() : true;
      refuseReviewersValid = this.$refs.refuseReviewersSettingRef ? this.$refs.refuseReviewersSettingRef.getValid() : true;
      if (!(nextReviewerValid && refuseReviewersValid)) {
        Skylark.Bridge.newAlertify('处理者为必填', {
          type: 'error'
        });
      }
      return nextReviewerValid && refuseReviewersValid;
    },
    resetEsignaturePad: function() {
      return this.$refs.esignatureSettingRef.resizeCanvas();
    },
    ensure: function() {
      var data, valid;
      valid = this.getValid();
      if (!valid) {
        return;
      }
      data = this.getData();
      if (!data) {
        return;
      }
      this.spinner = newSpinner({
        parent: this.$refs.modal.$refs.content
      });
      this.$emit('ensureClicked', data);
      if (this.$refs.esignatureSettingRef) {
        this.resetEsignaturePad();
      }
      return this.close();
    }
  }
});

export var newAssignmentSettingsModal = function(settings = {}) {
  return new AssignmentSettingsModal({
    el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('modal_container'),
    propsData: settings
  });
};
